import { Link } from "react-router-dom"
import './header.css'


function Header(){
  return(
    
    <header>

    <Link className="logo" to="/">
      <img src="/favicon.jpg" alt="GolbalTaxi" />
    </Link>
    <div className="links">
    <Link className="" to="/">Início</Link>
    <Link className="" to="/info">Info</Link>
    <Link className="" to="/contact">Contacto</Link>
    </div>
    
    
    </header>
   
  )
}
export default Header;